import {
  addWeeks,
  endOfISOWeek,
  endOfMonth,
  format,
  isAfter,
  isBefore,
  startOfDay,
  startOfISOWeek,
  startOfMonth,
} from 'date-fns';
import { dbDayDateToken } from 'server/static/dbDayDateToken';
import { AvailabilityWeek } from './availability-week.model';

export class AvailabilityMonth {
  public weeks: Array<AvailabilityWeek> = [];
  public startDateString: string;
  public startDate: Date;
  public endDate: Date;

  constructor(
    private iStartDate: Date,
    earlyEndDate?: Date,
    breakFrom?: Date,
    breakTo?: Date,
  ) {
    this.startDate = startOfDay(iStartDate);
    this.startDateString = format(iStartDate, dbDayDateToken);
    this.endDate = earlyEndDate ? earlyEndDate : endOfMonth(iStartDate);
    let currentWeekStart = startOfISOWeek(iStartDate);

    if (isBefore(currentWeekStart, this.iStartDate)) {
      currentWeekStart = iStartDate;
    }

    while (
      isBefore(currentWeekStart, this.endDate) &&
      (!breakFrom ||
        !breakTo ||
        isBefore(startOfMonth(currentWeekStart), breakFrom) ||
        isAfter(endOfMonth(currentWeekStart), breakTo))
    ) {
      if (
        !breakFrom ||
        !breakTo ||
        isBefore(currentWeekStart, breakFrom) ||
        isAfter(endOfISOWeek(currentWeekStart), breakTo)
      ) {
        this.weeks.push(
          new AvailabilityWeek(
            currentWeekStart,
            earlyEndDate,
            breakFrom,
            breakTo,
          ),
        );
      }
      currentWeekStart = startOfISOWeek(addWeeks(currentWeekStart, 1));
    }
  }
}
